<script>
import VectorLayer from 'ol/layer/Vector'
import VectorSource from 'ol/source/Vector'
import { Point } from 'ol/geom'
import parseStyle from '../ol-map/utils/style'
import Feature from 'ol/Feature'
import Select from 'ol/interaction/Select'

// 图形样式
const defaultEffect = {
  icon: {
    anchor: [0.5, 0.5],
    src: require('@/assets/images/common/icon02.png'),
    scale: 0.3
  }
}

// 选中样式
const selectedEffect = {
  icon: {
    anchor: [0.5, 0.5],
    src: require('@/assets/images/common/icon03.png'),
    scale: 0.3
  }
}

export default {
  name: 'ol-draw-point',

  inject: ['getMap'],

  props: {
    points: {
      type: Array,
      required: true
    }
  },

  watch: {
    points (payload) {
      this.source.clear()
      this.source.addFeatures(payload.map(point => {
        const feature = new Feature({ geometry: new Point([point.lon, point.lat]) })
        feature.setProperties(point)
        return feature
      }))
    }
  },

  data () {
    return {
      source: null
    }
  },

  created () {
    this.source = new VectorSource()
    if (this.points.length > 0) {
      this.source.addFeatures(this.points.map(point => {
        const feature = new Feature({ geometry: new Point([point.lon, point.lat]) })
        feature.setProperties(point)
        return feature
      }))
    }

    const vectorLayer = new VectorLayer({
      name: '设备分布',
      source: this.source,
      style: parseStyle(defaultEffect),
      zIndex: 99
    })

    const select = new Select({
      layers: [vectorLayer],
      style: parseStyle(selectedEffect)
    })
    select.on('select', event => {
      this.$emit('select', event.selected.length > 0 ? event.selected[0].getProperties() : '')
    })

    this.getMap(map => {
      map.addLayer(vectorLayer)
      map.on('pointermove', this.pointerMoveHandle)
      map.addInteraction(select)
    })
  },

  methods: {
    pointerMoveHandle (evt) {
      const pixel = evt.map.getEventPixel(evt.originalEvent)
      const feature = evt.map.forEachFeatureAtPixel(pixel, feature => {
        return feature
      })
      const element = evt.map.getTargetElement()
      if (feature === undefined || feature.getGeometry().getType() !== 'Point') {
        element.style.cursor = 'auto'
      } else {
        element.style.cursor = 'pointer'
      }
    }
  },

  render () {
    return null
  }
}
</script>
